import { render, staticRenderFns } from "./EventScanPage.vue?vue&type=template&id=4f0283fe"
import script from "./EventScanPage.vue?vue&type=script&lang=js"
export * from "./EventScanPage.vue?vue&type=script&lang=js"
import style0 from "./EventScanPage.vue?vue&type=style&index=0&id=4f0283fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports